import { CFormInput, CLoadingButton } from "@coreui/react-pro";
import Header from "../components/Header";
import { useState } from "react";
import { ToastInfo, ToastSuccess } from "@/components/shared/toast/Toast";
import axios from "@/shared/config/axios-interceptor";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/reducers";
import { AppDispatch } from "@/store";
import { getProfile } from "../../auth/auth.api";
import NganHangComponent from "../components/NganHangCompnent";
import { useTranslation } from "react-i18next";

const ThemTaiKhoanNganHang = () => {
  const { t }: { t: (key: string, options?: any) => string } = useTranslation();

  const dispatch = useDispatch<AppDispatch>();
  const { user } = useSelector((state: RootState) => state.authentication);
  const [bankName, setBankName] = useState("");
  const [cardName, setCardName] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [address, setAddress] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async () => {
    if (!bankName || !cardName || !cardNumber || !address) {
      ToastInfo(t("Vui lòng nhập đầy đủ thông tin!"));
      return;
    }

    try {
      setLoading(true);
      await axios.put(`/user/${user?.id}`, {
        bankName,
        cardName,
        cardNumber,
        address,
      });
      ToastSuccess(t("Thêm tài khoản ngân hàng thành công!"));
      dispatch(getProfile());
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  const checkExistBank = () => {
    return (
      user?.bankName && user?.cardName && user?.cardNumber && user?.address
    );
  };

  if (checkExistBank()) {
    return <NganHangComponent user={user} />;
  }

  return (
    <div className="wrapper">
      <div className="container-web themtaikhoannganhang bgnew">
        <Header title={t("Thêm tài khoản ngân hàng")} />

        <main>
          <div className="form-group">
            <CFormInput
              label={t("Tên ngân hàng")}
              placeholder={t("Hãy nhập tên ngân hàng")}
              value={bankName}
              onChange={(e) => setBankName(e.target.value)}
            />
          </div>

          <div className="form-group">
            <CFormInput
              label={t("Tên thật")}
              placeholder={t("Hãy nhập họ và tên của bạn")}
              value={cardName}
              onChange={(e) => setCardName(e.target.value)}
            />
          </div>

          <div className="form-group">
            <CFormInput
              label={t("Số tài khoản ngân hàng")}
              placeholder={t("Hãy nhập số tài khoản ngân hàng")}
              value={cardNumber}
              onChange={(e) => setCardNumber(e.target.value)}
            />
          </div>

          <div className="form-group">
            <CFormInput
              label={t("Địa chỉ ngân hàng")}
              placeholder={t("Hãy nhập địa chỉ ngân hàng")}
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
          </div>

          <div className="px-3 mt-4">
            <CLoadingButton
              onClick={onSubmit}
              className="w-100 rounded-1"
              loading={loading}
              disabled={loading}
            >
              {t("Thêm")}
            </CLoadingButton>
          </div>
        </main>
      </div>
    </div>
  );
};

export default ThemTaiKhoanNganHang;
